module.exports = __webpack_public_path__ + "static/media/gen-europe.44ef6ca7.png";